export const getActionCardClassName = (
	baseClass: string,
	variant: string,
	variantClassPrefix: string = 'card'
) => {
	const variantName = variant.charAt(0).toUpperCase() + variant.slice(1);
	const variantClass = `${variantClassPrefix}${variantName}`;
	return { baseClass, variantClass };
};
